import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiCheckCircle, FiClock, FiMapPin, FiPhone } from "react-icons/fi";
import "./Hero.css";

function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 150);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <section className={`hero ${scrolled ? "active" : ""}`}>

      <div className="hero-bg"></div>
      <div className="hero-overlay"></div>


      <div className="container hero-content">

        <motion.div
          className="badge"
          initial={{opacity:0,y:20}}
          animate={{opacity:1,y:0}}
        >
          <FiClock />
          Available 24/7 Across Cape Town
        </motion.div>



        <motion.h1
          initial={{opacity:0,y:40}}
          animate={{opacity:1,y:0}}
          transition={{delay:.2}}
        >
          Locked Out?
          <span>
            We’ll Get You Back Inside Fast.
          </span>
        </motion.h1>



        <motion.p
          initial={{opacity:0}}
          animate={{opacity:1}}
          transition={{delay:.4}}
        >
          Emergency locksmith services for homes,
          businesses and vehicles. Fast response,
          professional technicians and reliable security
          solutions.
        </motion.p>



        <motion.div
          className="hero-buttons"
          initial={{opacity:0,y:20}}
          animate={{opacity:1,y:0}}
          transition={{delay:.6}}
        >

          <a 
          href="tel:+27604971899"
          className="primary-btn"
          >
            <FiPhone/>
            Emergency Call
          </a>


          <a 
          href="#services"
          className="secondary-btn"
          >
            View Services
          </a>

        </motion.div>



        <motion.div
        className="trust-row"
        initial={{opacity:0}}
        animate={{opacity:1}}
        transition={{delay:.8}}
        >

          <div>
            <FiCheckCircle/>
            Licensed
          </div>

          <div>
            <FiClock/>
            30 Min Response
          </div>

          <div>
            <FiMapPin/>
            Cape Town Wide
          </div>

        </motion.div>


      </div>

    </section>
  );
}


export default Hero;